if (!window.zelloSharedMessages) {
    var zelloSharedMessages = {};
}
(function ($) {
   
	if (typeof(wp) === 'object') {

		var htmlEncode = function(value) {
			if (!value) {
				return "";
			}
			return $('<div/>').text(value).html();
		};

		var renderFromBlock = (function(){
			var lt, rt = null;
			return function() {
				$('.current-speaker-carousel').width($('.jp-info-data').width()-20);
				var x = $('.current-speaker-carousel').width(), ox = $('.current-speaker-carousel span').width();
				var speed = (ox-x) * 30;
				var pause = 1000;
				if (lt)
					clearTimeout(lt);
				if (rt)
					clearTimeout(rt)
				var l = function() {
					lt = setTimeout(function() {
						$('.current-speaker-carousel').animate({
							left: -(ox-x)
						}, speed, 'linear', function() { r(); });
					}, pause);
				};
				var r = function() {
					rt = setTimeout(function() {
						$('.current-speaker-carousel').animate({
							left: 0
						}, speed, 'linear', function() { l(); });
					}, pause);
				};
				if (ox > x) {
					l();
				}
			};
		})();
		
		var loadingJSON = false;

		zelloSharedMessages = {
			init: function()
			{
				this.loadSharedMessages();
				this.searchForm();
			},
			templateLoader: function(sourceURL, excludedSelector)
			{

				var templateClass = $('.tmpl_wp_sm').not(excludedSelector);

				templateClass.each(function() {
					var thisTemplate = $(this);
					var templateID = thisTemplate.attr('id');
					var templateTarget = $( '.js--' + templateID );
					var templateName = templateID.substr(5);
					var template = wp.template( templateName );

					$.getJSON( sourceURL, function(data) {
						templateTarget.html(template(data));
						zelloSharedMessages.extractLetterForPlaceholderImage();
						zelloSharedMessages.paginationLoader();
						zelloSharedMessages.helperEvents();
						loadingJSON = false;
					});
				});
			},
			paginationLoader: function()
			{
				var hash = decodeURIComponent(location.hash.substr(1));
				var pathname = hash.split( '/' );
				var hashBase = pathname[0];
				var urlEnd = '';
				if (!pathname[0]) {
					hashBase = 'popular';
				}
				if (pathname[2]) {
					urlEnd = pathname[2] + '/';
				}
				$('.s-channels-pagination a[data-page]').each(function() {
					var urlBase = $(this).attr('data-href');
					var pageNumber = $(this).attr('data-page');
					$(this).attr('href', urlBase + hashBase + '/' + pageNumber + '/' + urlEnd);
				});
			},
			loadSharedMessages: function()
			{
				var messageCode = getUrlParameter('k');
				//var messageCode = getUrlID(3);
				if( messageCode!='' && messageCode!=undefined ){
					loadingJSON = true;
                    var APIurl = 'https://zello.com/shared/';
                    var sourceURL = APIurl;
					sourceURL = APIurl+'api/'+messageCode;
                	//sourceURL = '/json/'+messageCode+'.json';
					zelloSharedMessages.templateLoader(sourceURL);
					$('.shared-messages-single').show();
					$('.shared-messages-list').hide();
				}else{
					$(window).bind( 'hashchange', function() {
						if ( !loadingJSON ) {
							loadingJSON = true;
							var APIurl = 'https://zello.com/shared';
							var sourceURL = APIurl;
							var hash = decodeURIComponent(location.hash.substr(1));
							var baseURL;
							baseURL = APIurl;
							var lastChar = baseURL.substr(-1);
							if (lastChar == '/') {
								baseURL = baseURL.slice(0, -1);
							}
							var pathname = hash.split( '/' );
							var query = '';
							var searchVal = '';
							var pageNumber = pathname[1];

							if (!pathname[1]) {
								pageNumber = 1;
							}
							if (pathname[2]) {
								searchVal = pathname[2];
							}
							if( searchVal!='' && searchVal!=undefined ){
								sourceURL = baseURL + '/api'+searchVal+'&page=' + pageNumber + '&max=10';
							}else{
								sourceURL = baseURL + '/api?page=' + pageNumber + '&max=10';
							}
							//sourceURL = '/json/shared.json' + '?page=' + pageNumber + '&' + query + 'max=10';
							zelloSharedMessages.templateLoader(sourceURL);

							searchVal = zelloSharedMessages.getAllUrlParams(hash);

							if( searchVal.tochannel ){
								$('.messages-search-form input[data-search-filter="toChannel"]').val( searchVal.tochannel );
							}
							if( searchVal.fromuser ){
								$('.messages-search-form input[data-search-filter="fromUser"]').val( searchVal.fromuser );
							}
							if( searchVal.sharedby ){
								$('.messages-search-form input[data-search-filter="sharedBy"]').val( searchVal.sharedby );
							}
							if( searchVal.filteroptions ){
								$('.messages-search-form input[data-search-filter="filterOptions"]').val( searchVal.filteroptions );
							}

							$("html, body").animate({ scrollTop: 0 }, "slow");
							$('.shared-messages-list').show();
							$('.shared-messages-single').hide();
						}
					});
					$(window).trigger( 'hashchange' );
				}
			},
			searchForm: function()
			{
				$(document.body).on('submit', '.messages-search-form', function(e) {

					e.preventDefault();
					var serachFilter = '';
					var searchVal = '';
					var searchValFilter = '';
					$(this).find('.search-filter').each(function( index ) {
						if( $(this).val()!='' && $(this).val()!=undefined ){
							searchFilter = $(this).data('search-filter');
							searchVal = $(this).val();
							searchValFilter += searchFilter+'='+searchVal+'&';
						}
					});
					searchValFilter = searchValFilter.slice(0,-1);

					var searchPageURL = window.location.pathname + '#search/1/?' + searchValFilter;

					if (!searchValFilter) {
						searchPageURL = window.location.pathname;
					}
					window.history.pushState({}, '', searchPageURL);
					$(window).trigger( 'hashchange' );
				});
			},
			getAllUrlParams: function(url) {
				var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
				var obj = {};
				if (queryString) {
					queryString = queryString.split('#')[0];
					var arr = queryString.split('&');
					for (var i=0; i<arr.length; i++) {
						var a = arr[i].split('=');
						var paramNum = undefined;
						var paramName = a[0].replace(/\[\d*\]/, function(v) {
						paramNum = v.slice(1,-1); return '';});
						var paramValue = typeof(a[1])==='undefined' ? true : a[1];
						paramName = paramName.toLowerCase();
						paramValue = paramValue.toLowerCase();
						if (obj[paramName]) {
							if (typeof obj[paramName] === 'string') {
								obj[paramName] = [obj[paramName]];
							}
							if (typeof paramNum === 'undefined') {
								obj[paramName].push(paramValue);
							}else {
								obj[paramName][paramNum] = paramValue;
							}
						}else {
							obj[paramName] = paramValue;
						}
					}
				}
			return obj;
			},
			extractLetterForPlaceholderImage: function()
			{
				var element = $( 'svg.single-channel__item--image text' );
				element.each(function() {
					var singleElement = $(this)
					var singleElementName = singleElement.attr('data-name');
					singleElement.text(singleElementName.substr(0,1).toUpperCase());
				});
			},
			helperEvents: function()
			{
				var srcFile = $('#message-audio-url').val();
				$("#jquery_jplayer_1").jPlayer({
					solution: 'html',
					supplied: 'mp3',
					preload: 'auto',
					volume: 0.8,
					muted: false,
					backgroundColor: '#000000',
					cssSelectorAncestor: '#jp_container_1',
					cssSelector: {
						videoPlay: '.jp-video-play',
						play: '.jp-play',
						pause: '.jp-pause',
						stop: '.jp-stop',
						seekBar: '.jp-seek-bar',
						playBar: '.jp-play-bar',
						mute: '.jp-mute',
						unmute: '.jp-unmute',
						volumeBar: '.jp-volume-bar',
						volumeBarValue: '.jp-volume-bar-value',
						volumeMax: '.jp-volume-max',
						playbackRateBar: '.jp-playback-rate-bar',
						playbackRateBarValue: '.jp-playback-rate-bar-value',
						currentTime: '.jp-current-time',
						duration: '.jp-duration',
						title: '.jp-title',
						fullScreen: '.jp-full-screen',
						restoreScreen: '.jp-restore-screen',
						repeat: '.jp-repeat',
						repeatOff: '.jp-repeat-off',
						gui: '.jp-gui',
						noSolution: '.jp-no-solution'
					},
					errorAlerts: false,
					warningAlerts: false,
					ready: function (event) {
						$(this).jPlayer("setMedia", {
						mp3: srcFile
						});
					},
					seeking: function() {
						$('div.message').removeClass('searching');
						currentSubMessage.addClass('searching');
					},
					seeked: function() {
						$('div.message').removeClass('searching');
					},
					play: function() {
			
					},
					pause: function() {
						$('div.message').find('.playback-control').addClass('icon-play').removeClass('icon-pause');
					},
					suspend: function() {
						$('div.message').find('.playback-control').addClass('icon-play').removeClass('icon-pause');
					},
					timeupdate: function(event) {
						var c = $("#jquery_jplayer_1").data("jPlayer").status.currentTime;
						var messageEl = $('div.message');
						$('div.jp-info-data').html('');
						if (!c) {
							zelloSharedMessages.setActiveMessage(messageEl.eq(0));
							return false;
						}
						c = c*1000;
						messageEl.each(function() {
							var skip = $(this).attr('skip');
							var end = $(this).attr('end');
							if (c>skip && c<end) {
								zelloSharedMessages.setActiveMessage($(this));
							}
						});
						messageEl.find('.playback-control').addClass('icon-play').removeClass('icon-pause');
						if ($('#jquery_jplayer_1').data().jPlayer.status.paused) {
							$('div.message.active').find('.playback-control').addClass('icon-play').removeClass('icon-pause');
						} else {
							$('div.message.active').find('.playback-control').removeClass('icon-play').addClass('icon-pause');
						}
					},
				});
			},
			setActiveMessage: function(m) {
				$('div.message').removeClass('active').removeClass('message-inverse').find('.playback-control').removeClass('icon-white');
				var info = {
					from: htmlEncode(m.attr('from')),
					to: htmlEncode(m.attr('to')),
					toChannel: htmlEncode(m.attr('toChannel')),
					toLocalChannel: (m.attr('toLocalChannel')=='true'),
					channelShortHash: m.attr('channelShortHash'),
					date: m.attr('date')
				};
				var templateInfo = wp.template('shared-message-info');
				$('.jp-info-data').html(templateInfo(info));
				m.addClass('active').addClass('message-inverse');
				m.find('.playback-control').addClass('icon-white');
				renderFromBlock();
			},
			tsToDate: function (UNIX_timestamp){
				var a = new Date(UNIX_timestamp*1000);
				var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
				var year = a.getFullYear();
				var month = a.getMonth()+1;
				var date = a.getDate();
				var hour = a.getHours();
				var min = a.getMinutes();
				var sec = a.getSeconds();
				return date+'.'+sprintf('%02d',parseInt(month))+'.'+year+' '+sprintf('%02d', parseInt(hour))+':'+sprintf('%02d',parseInt(min));
			}
		};
		$(document).ready(function() {
			zelloSharedMessages.init();
			$('body').on('click', '.js--report-abusive-content', function(e){
				e.preventDefault();
				var key = $(this).attr('key');
				var $this = $(this);
				var actionUrl = 'https://zello.com/shared/report/abusive/'+key;
				$.ajax({
					url: actionUrl,
					cache: false,
					method: 'post',
				})
				.done(function(response){
					$('.abusive-report-saved').removeClass('hidden');
					$('.abusive-report-ready').addClass('hidden');
					$this.addClass('disabled').unbind('click');
				})
				.always(function(xhr) {
					var xhrStatus = xhr.status;
					if( xhrStatus == '400' ){
					}
				});
			});
			$('body').on('click', 'div.message', function() {
				currentSubMessage = $(this);
				if (!$('#jquery_jplayer_1').data().jPlayer.status.paused && currentSubMessage.hasClass('active')) {
					$("#jquery_jplayer_1").jPlayer("pause");
				} else {
					if (currentSubMessage.hasClass('active')) {
						$("#jquery_jplayer_1").jPlayer("play");
					} else {
						$("#jquery_jplayer_1").jPlayer("play", parseInt($(this).attr('skip'))/1000 );
					}
				}
			});
		});
	}
})(jQuery);